import { render, staticRenderFns } from "./RflmUnpaidSpouseSupport.vue?vue&type=template&id=1d4d3c50"
import script from "./RflmUnpaidSpouseSupport.vue?vue&type=script&lang=ts"
export * from "./RflmUnpaidSpouseSupport.vue?vue&type=script&lang=ts"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports